import axios from 'axios';

import { CacheService } from '../services/Cache.Service';

import { ISecurityPool } from '../common/Types';

const cacheTtlInMs = 600000;

export const SecurityService = {
  getAll: async (
    authToken: string,
    signalSourceShortName: string,
    forceRefresh: boolean = false):
    Promise<ISecurityPool[]> => {
    const response = await CacheService.getAndUpdate(
      authToken,
      'signalsources/' + signalSourceShortName + '/securitypools',
      cacheTtlInMs,
      forceRefresh);
    return response as ISecurityPool[];
  },

  get: async (
    authToken: string,
    signalSourceShortName: string,
    securityPoolShortName: string,
    forceRefresh: boolean = false):
    Promise<ISecurityPool> => {
    const response = await CacheService.getAndUpdate(
      authToken,
      'signalsources/' + signalSourceShortName + '/securitypools/' + securityPoolShortName,
      cacheTtlInMs,
      forceRefresh);
    return response as ISecurityPool;
  },

  create: async (
    authToken: string,
    signalSourceShortName: string,
    items: ISecurityPool[]):
    Promise<ISecurityPool[] | undefined> => {
    const endpoint = 'signalsources/' + signalSourceShortName + '/securitypools';
    const headers = {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + authToken
    };

    try {
      const apiresult = await axios.post(
        process.env.REACT_APP_PORTAL_API_ENDPOINT + '/api/' + endpoint,
        items,
        { headers: headers }
      );

      return apiresult.data as ISecurityPool[];
    } catch (err) {
      console.log(err);
      return undefined;
    }
  },

  createOrUpdate: async (
    authToken: string,
    signalSourceShortName: string,
    items: ISecurityPool[]):
    Promise<ISecurityPool[] | undefined> => {
    const endpoint = 'signalsources/' + signalSourceShortName + '/securitypools';
    const headers = {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + authToken
    };

    try {
      const apiresult = await axios.put(
        process.env.REACT_APP_PORTAL_API_ENDPOINT + '/api/' + endpoint,
        items,
        { headers: headers }
      );

      return apiresult.data as ISecurityPool[];
    } catch (err) {
      console.log(err);
      return undefined;
    }
  },

  delete: async (
    authToken: string,
    signalSourceShortName: string,
    securityPoolShortName: string):
    Promise<boolean | null> => {
    const endpoint = 'signalsources/' + signalSourceShortName + '/securitypools/' + securityPoolShortName;
    const headers = {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + authToken
    };

    try {
      const apiresult = await axios.delete(
        process.env.REACT_APP_PORTAL_API_ENDPOINT + '/api/' + endpoint,
        { headers: headers }
      );

      return (apiresult.status >= 200 && apiresult.status < 300);
    } catch (err) {
      console.log(err);
      return false;
    }
  }
};
